/* eslint-disable no-nested-ternary */
import styled from 'styled-components'
import { colors } from '../../theme'

export const SpanIcon = styled.button`
  position: absolute;
  top: 16px;
  left: 295px;
  height: 42px;
  width: 42px;
  background-color: ${colors.grey100};
  border: none;
  cursor: pointer;
  padding: 9px 9px 9px 10px;
  border-radius: 9px;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: flex;
`
export const Container = styled.div`
  margin-top: 30px;
  position: relative;
`
export const FilterStatus = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 285px;
  top: 68px;
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: 230px;
`
export const SpanFilter = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 0 0;
  gap: 10px;
  color: ${colors.grey900};
  border-bottom: 1px solid ${colors.grey300};
  padding-bottom: 10px;
  margin-bottom: 5px;
`
export const WrapperTitle = styled.div`
  margin-top: 20px;
`

export const Ul = styled.ul`
  list-style: none;
`
export const Li = styled.li`
  margin: 10px 0;
`
export const Td = styled.div<{ classification: string }>`
  background-color: ${({ classification }) =>
    classification === 'EM_ALTA'
      ? `${colors.lightGreen}`
      : classification === 'EM_BAIXA'
      ? `${colors.lightRed}`
      : `${colors.lightBlue}`};
  color: ${({ classification }) =>
    classification === 'EM_ALTA'
      ? `${colors.secondaryText}`
      : classification === 'EM_BAIXA'
      ? `${colors.errorText}`
      : `${colors.system}`};
  padding: 7px;
  border-radius: 9px;
  width: 100px;
  margin: 0 auto;
  text-transform: capitalize;
  text-align: center;
`
